<div class="grid grid-cols-12 transition-transform duration-100 w-full grow bg-white/90 rounded-lg shadow-lg">
    @for (month of [1,2,3,4,5,6,7,8,9,10,11,12]; track month) {
    <div
        class="uppercase relative h-8 w-full text-center text-xs  top-0 shrink-0 flex items-center justify-center border-r border-grey-50">
        <div class=" text-grey-700 font-medium bg-white flex items-center justify-center transition-all duration-100">
            @if (month !== currentMonth) {
            <span>{{('common.months.' + month |
                translate).slice(0,1)}}</span>
            }
            <span [ngClass]="{'opacity-0': month !== currentMonth, '-right-6': month === 12}"
                class="absolute bg-primary text-white p-1 px-2 rounded-lg bottom-[38px] transition-opacity duration-300">{{('common.months.'
                +
                month |
                translate)}}</span>
        </div>
    </div>
    }
</div>